module.exports = __webpack_public_path__ + "media/images/job-board-logos-96098213fede64be739fa66eeceb4b0d.svg";